import { render, staticRenderFns } from "./suitch-thermo.vue?vue&type=template&id=80ff5b9c&"
import script from "./suitch-thermo.vue?vue&type=script&lang=js&"
export * from "./suitch-thermo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports